import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

type SupportConfig = {
  className: string;
  title: string;
  anchor: string;
  label: string;
};

type NavConfig = { dataTrackAction: string } & SupportConfig;

const locale = ApplicationDomainUtility.locale;
const backtestYearsCountMap = {
  crypto: '1',
  in: '6+',
};
const allNavConfig: NavConfig[] = [
  {
    className: '',
    title: 'Terms & Conditions',
    anchor: '/terms_and_conditions',
    label: ' Terms & Conditions ',
    dataTrackAction: 'termandconditions',
  },
  {
    className: '',
    title: 'Policy',
    anchor: '/policy',
    label: ' Policy ',
    dataTrackAction: 'Policy',
  },
  {
    className: '',
    title: 'About us',
    anchor: '/about_us',
    label: ' About us ',
    dataTrackAction: 'Policy',
  },
  {
    className: '',
    title: 'Best Algo',
    anchor: '/best-algo-trading-software',
    label: ' Best Algo ',
    dataTrackAction: 'bestalgo',
  },
  {
    className: '',
    title: 'Top 10 Algorithmic Platforms',
    anchor: '/top-10-algo-trading-platforms',
    label: ' Top 10 Algorithmic Platforms ',
    dataTrackAction: 'topalgorithmicplatforms',
  },
  {
    className: '',
    title: 'Faq',
    anchor: '/faq',
    label: ' Faq ',
    dataTrackAction: 'FAQ',
  },
  {
    className: '',
    title: 'Videos',
    anchor: '/learningvideos',
    label: ' Videos ',
    dataTrackAction: 'Videos',
  },
  {
    className: '',
    title: 'Blog',
    anchor: '/blog',
    label: ' Blogs ',
    dataTrackAction: 'blog',
  },
];

const allSocialMediaConfig = [
  {
    iconName: '/1.svg',
    dataTrackAction: 'twitter',
    anchor: 'https://twitter.com/quantman1',
  },
  {
    iconName: '/2.svg',
    dataTrackAction: 'youtube',
    anchor: 'https://www.youtube.com/c/quantman',
  },
  {
    iconName: '/3.svg',
    dataTrackAction: 'insta',
    anchor: 'https://www.instagram.com/quantman_algotrading/',
  },
  {
    iconName: '/5.svg',
    dataTrackAction: 'whatsapp',
    anchor: 'https://api.whatsapp.com/send/?phone=%2B917200583536&text&type=phone_number&app_absent=0',
  },
  {
    iconName: '/6.svg',
    dataTrackAction: 'email',
    anchor: 'mailto:support@quantman.in',
  },
  {
    iconName: '/7.svg',
    dataTrackAction: 'linkedin',
    anchor: 'https://www.linkedin.com/company/quantman/',
  },
  {
    iconName: '/8.svg',
    dataTrackAction: 'facebook',
    anchor: 'https://www.facebook.com/quant.man.16/',
  },
];

export const productName = ApplicationDomainUtility.productName;

export const emailAddress = (() => {
  switch (locale) {
    case 'in':
      return 'support@quantman.in';
    // temp remove for razorpay review
    // case 'crypto':
    //   return `support@cryptobot.in`;
    default:
      return `support@${_.toLower(productName)}.in`;
  }
})();

export const backtestYearsCount = _.get(backtestYearsCountMap, locale, '6+');

const supportConfigMap = (locale: string): SupportConfig[] => {
  switch (locale) {
    // temp remove for razorpay review
    // case 'crypto':
    //   return [
    //     { className: '', title: 'Crypto Support', anchor: 'tel:9361078389', label: 'Phone: 9361078389' },
    //     {
    //       className: '',
    //       title: 'Business partnership franchise Bulk sales',
    //       anchor: 'tel:7200397082',
    //       label: 'Business partnership: 7200397082',
    //     },
    //   ];
    default:
      // SAFL COMPANY SUPPORT NUMBERS
      return [
        { className: '', title: 'English Support', anchor: 'tel:9043044901', label: 'English: 9043044901' },
        { className: '', title: 'Tamil Support', anchor: 'tel:9043044901', label: 'Tamil: 9043044901' },
        { className: '', title: 'Hindi Support', anchor: 'tel:7305977320', label: 'Hindi: 7305977320' },
        {
          className: '',
          title: 'Business partnership franchise Bulk sales',
          anchor: 'tel:7200397082',
          label: 'Business Partnership: 7200397082',
        },
      ];
  }
};

export const supportConfig: SupportConfig[] = supportConfigMap(locale);

export const navConfig: NavConfig[] = locale === 'crypto' ? allNavConfig.slice(0, 3) : allNavConfig;

export const socialMediaConfig = locale === 'crypto' ? [] : allSocialMediaConfig;

export const getAddress = () => {
  switch (locale) {
    case 'in':
      return `No. 418, First Floor, G.V. Residency, Sowripalayam, Coimbatore, Tamil Nadu - 641015.`;
    // temp remove for razorpay review
    // case 'crypto':
    //   return `Ground Floor, 2,3, Vallalar Street, Ansariduraisamy Nagar, Keerapalayam, Puducherry, 605004`;
    default:
      return `No. 418, First Floor, G.V. Residency, Sowripalayam, Coimbatore, Tamil Nadu - 641015.`;
  }
};
